import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

import { Icon } from "@iconify/vue";
import { computed } from "vue";
import type { Size, Variant } from "./types";

interface Props {
  variant?: Variant | "info" | "light";
  size?: Size;
  rounded?: boolean;
  closable?: boolean;
  clickable?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Badge',
  props: {
    variant: { default: "primary" },
    size: { default: "md" },
    rounded: { type: Boolean, default: false },
    closable: { type: Boolean, default: false },
    clickable: { type: Boolean, default: false }
  },
  emits: ["click", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const badgeClasses = computed(() => {
  const classes = ["ui-badge"];
  classes.push(`ui-badge--${props.variant}`);
  classes.push(`ui-badge--${props.size}`);
  if (props.rounded) classes.push("ui-badge--rounded");
  if (props.clickable) classes.push("ui-badge--clickable");
  if (props.closable) classes.push("ui-badge--closable");
  return classes;
});

const handleClick = (event: MouseEvent) => {
  if (props.clickable) {
    emit("click", event);
  }
};

const handleClose = () => {
  emit("close");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(badgeClasses.value),
    onClick: handleClick
  }, [
    _renderSlot(_ctx.$slots, "default"),
    (__props.closable)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "ui-badge__close",
          onClick: _withModifiers(handleClose, ["stop"])
        }, [
          _createVNode(_unref(Icon), { icon: "mdi:close" })
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})